import { useCallback, useEffect, useState } from 'react';

import BudgetCurrencyInput from '../../createAndEdit/components/BudgetCurrencyInput';

interface IBudgetCounterProposalProps {
  counterProposal?: boolean;
  counterProposalValue?: number;
  counterProposalObs?: string;
  onCounterProposalValueChange?: (value: number) => void;
  onCounterProposalObsChange?: (value: string) => void;
  readOnly?: boolean;
}

const DetailCounterProposal = (props: IBudgetCounterProposalProps) => {
  const [observation, setObservation] = useState<string>(props.counterProposalObs || '');
  const [value, setValue] = useState<number>(props.counterProposalValue || 0);

  useEffect(() => {
    setObservation(props.counterProposalObs || '');
  }, [props.counterProposalObs]);

  useEffect(() => {
    setValue(props.counterProposalValue || 0);
  }, [props.counterProposalValue]);

  const handleObservationChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      setObservation(newValue);
      props.onCounterProposalObsChange?.(newValue);
    },
    [props],
  );

  const handleValueChange = useCallback(
    (newValue: number) => {
      setValue(newValue);
      props.onCounterProposalValueChange?.(newValue);
    },
    [props],
  );

  if (!props.counterProposal) {
    return null;
  }

  const formatCurrency = (val: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(val);
  };

  return (
    <div className="m-6 px-4 border-2  border-gray-100 dark:border-neutral-700 rounded-md p-4">
      <div className="flex flex-row items-center mb-4">
        <div className="font-bold text-size-14 text-gray-700 dark:text-neutral-300">Contraproposta</div>
      </div>

      <div className="flex flex-row gap-4">
        <div className="flex-1">
          <div className="font-bold mb-2 text-size-12 text-gray-500 dark:text-neutral-400">Observação</div>
          {props.readOnly ? (
            <div className="p-2 bg-white dark:bg-neutral-800 rounded border border-gray-200 dark:border-neutral-700 min-h-[40px] text-size-14">
              {observation || '-'}
            </div>
          ) : (
            <textarea
              className="form-control w-full"
              rows={1}
              placeholder="Insira um texto em caso de contraproposta"
              value={observation}
              onChange={handleObservationChange}
            />
          )}
        </div>

        <div className="w-45 ml-2">
          <div className="font-bold mb-2 text-size-12 text-gray-500 dark:text-neutral-400">Valor da contraproposta</div>
          {props.readOnly ? (
            <div className="p-2 bg-white dark:bg-neutral-800 rounded border border-gray-200 dark:border-neutral-700 min-h-[40px] text-size-14 flex items-center">
              {value > 0 ? formatCurrency(value) : '-'}
            </div>
          ) : (
            <BudgetCurrencyInput value={value} onChange={handleValueChange} placeholder="R$ 0,00" />
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailCounterProposal;
